import { __awaiter, __generator } from "tslib";
import { APP_DEFINITION_ID } from '@wix/wixstores-client-core';
import { Theme } from '@wix/payment-methods-banner/dist/src/types/Theme';
export var getPaymentMethodsBannerProps = function (siteStore, options) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, siteStore.loadClientConfig()];
            case 1:
                _a.sent();
                return [2 /*return*/, {
                        meta: {
                            appDefId: APP_DEFINITION_ID,
                            appInstanceId: siteStore.storeId,
                            appInstance: siteStore.instanceManager.getInstance(),
                            productId: options.productId,
                            msid: siteStore.storeId,
                            host: siteStore.location.baseUrl,
                            visitorId: siteStore.uuid,
                        },
                        amount: options.amount,
                        currency: siteStore.getCurrentCurrency(),
                        demoMode: siteStore.isEditorMode() || siteStore.isPreviewMode(),
                        deviceType: siteStore.isMobile() ? 'mobile' : 'desktop',
                        isSSR: siteStore.isSSR(),
                        locale: siteStore.locale,
                        theme: options.theme ? options.theme : Theme.Light,
                        onFullLoad: options.onFullLoad,
                        onEmpty: options.onEmpty,
                    }];
        }
    });
}); };
//# sourceMappingURL=getPaymentMethodsBannerProps.js.map